import {UserJwtDecode} from "@/services/authentication.service";
import {BehaviorSubject, Observable} from "rxjs";
import {map} from "rxjs/operators";
import GlobalStore from "@/store/modules/global";
import {User} from "@/models/user";
import {router} from "@/router";
import {Auth} from "@/models/auth";
import JwtDecode from "jwt-decode";
import {BASE_PATH_APP} from "@/commons/config";
import {AuthApi} from "@/api/sie-pedidos/auth.api";
import {ExpireJwtDecode} from "@/services/transportadora.auth.service";

const AUTH = `${BASE_PATH_APP}-sie-pedidos-auth`
const api = new AuthApi();
const currentUser = () => {
  const { token = null, functionalities = [], perfis = [] } = JSON.parse(localStorage.getItem(AUTH)) || {}
  if (!token) return null
  const { sub, name, username, email, roles, sector } = JwtDecode<UserJwtDecode>(token)
  return new User(sub, name, username, email, sector, functionalities, roles, perfis)
}

const userSubject = new BehaviorSubject(currentUser())

const globalStore = (type: string, mensage: string) => {
  GlobalStore.setSnackBar({
    show: true,
    message: mensage,
    type :type,
    timeout: 4000,
  });
}
const dadosUserLogado = () => {
  return new Promise((resolve, reject) => {
    api.dadosUserLogado().subscribe({
      next: (response) => {
        setUserLocalStore(response['result'].nomeUsuario, response['result'].siglaEntidade)
        resolve(true)
      },
      error: (error) => {
        const {response: {data: {message}}} = error;
        removeAuth()
        globalStore("error", message)
        reject(false)
      }
    })
  })
}

const dadosUserGraficaLogado = () =>{
  return new Promise((resolve, reject) => {
    api.dadosUserGraficaLogado().subscribe({
      next: (response) =>{
        setUserLocalStore(response['result'].nomeUsuario, response['result'].graficaRazaoSocial)
        resolve(true)
      },
      error: (error) =>{
        const {response: {data: {message}}} = error;
        removeAuth()
        globalStore("error", message)
        reject(false)
      }
    })
  })
}

const verifyAutorization = () =>{
  if(authorizeEntidade()) {
    dadosUserLogado().then(result=> {if (result) router.push("/carteira-macrorregiao/entidade/criar-solicitacao")})
  }else if(authorizeGrafica()) {
    dadosUserGraficaLogado().then(result=> {if (result) router.push("/carteira-macrorregiao/grafica/lote")})
  } else {
    globalStore("error", "Erro: usúario não autorizado!")
  }
}
const login = (usernameOrEmail: string, password: string) => {
  api
    .signin(usernameOrEmail, password)
    .pipe(map(response => setSession(response))).subscribe({
    next: () =>{
      verifyAutorization()
    },
    error: (error) =>{
      const {response: {data: {message}}} = error;
      globalStore("error", message)}
  })
}
const setSession = (authResult: any): User => {
  buildAuth(authResult)
  userSubject.next(currentUser())
  return userSubject.value
}
const buildAuth = ({ token, functionalities }: Auth) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }))
}

const removeAuth = () => {
  localStorage.removeItem(AUTH);
  localStorage.removeItem("dadosUserLogado");
  userSubject.next(null);
}
const logout = (isEntidade?: boolean): void => {
  removeAuth()
  if(isEntidade) router.push("/carteira-macrorregiao/login-entidade");
  else router.push('/carteira-macrorregiao/login-grafica/')
};

const validateEntidade = (): boolean =>{
  const user = currentUser();
  return  user?.perfis?.some(v => v === 'CENTRALDESERVICOS-SIE-ENTIDADE');
}

const isEntidade = (): boolean =>{
  const { meta: {authorize}, name } = router.currentRoute;
  return name === 'login-entidade'
}

const isGrafica = (): boolean =>{
  const { meta: {authorize}, name } = router.currentRoute;
  return name === 'login-grafica'
}


const authorizeEntidade = (): boolean =>{
  return isEntidade() && validateEntidade();
}

const validateGrafica = (): boolean =>{
  const user = currentUser()
  return  user?.perfis?.some(v => v === 'CENTRALDESERVICOS-SIE-GRAFICA');
}

const authorizeGrafica = (): boolean =>{
  return isGrafica() && validateGrafica();
}

const getUser = (): number=>{
  const user = currentUser()
  return user?.id
}
const recuperarSenha = (usernameOrEmail: string): Observable<any> => {
  return api
    .recuperarSenha(usernameOrEmail)
    .pipe(map(response => setSession(response)))
}

const setUserLocalStore = (user, sigla) =>{
  localStorage.setItem("dadosUserLogado", JSON.stringify({name: user, sigla: sigla}))
}

const expiredToken = () =>{
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const { exp } = JwtDecode<ExpireJwtDecode>(token);
  return exp * 1000;
}

const isEntidadeRecuperarSenha = () =>{
  const { meta: {authorize}, name } = router.currentRoute;
  return name === 'recuperar-senha-entidade'
}

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {}
  return token
}

export default {
  login, logout, validateEntidade,
  validateGrafica, authorizeEntidade,
  authorizeGrafica, getUser,
  recuperarSenha,
  removeAuth,
  isEntidade, globalStore,
  setUserLocalStore,dadosUserLogado, dadosUserGraficaLogado,
  expiredToken, isEntidadeRecuperarSenha,
  get token() {
    return currentToken();
  },
}
